import { Grid, Icon } from "@mui/material";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "layouts/Footer";
import MDInput from "components/MDInput";
import { useState, useCallback, useEffect } from "react";
import TitleCustom from "components/CustomTitle";
import { data, detailLevel, reportType, terms } from "./searchOptions/searchOptions";
import CommonSelectWithoutNoneOption from "components/CommonSelect/selectWithoutNoneOption";
import MultipleSelectChip from "../por_principio_activo/components/multiSelectChips";
import { getCatalogSectorsSync } from "rest/sync/requestsSync";
import { getCatalogSubSectorsSync } from "rest/sync/requestsSync";
import { getCatalogGroupsSync } from "rest/sync/requestsSync";
import { getCatalogCategoriesSync } from "rest/sync/requestsSync";
import getSector from "../por_principio_activo/data/getCatalogTypeId2";
import getSubSector from "../por_principio_activo/data/getCatalogTypeId3";
import getGrupos from "../por_principio_activo/data/getCatalogTypeId1";
import getCategories from "../por_principio_activo/data/getCatalogTypeId6";
import MDButton from "components/MDButton";
import { analysisVeterinaryMarket } from "rest/requests";
import MarketAnalysisTable from "./components/customTable";
import { getExcelData } from "./getExcelData";
import { MarketAnalysisCharts } from "./showCharts";
import DetailsDialog from "./components/DetailsCompanyDialog";
import { reportAnalysisVeterinaryMarketDetail } from "rest/requests";
import { reportAnalysisVeterinaryMarketDetailCategory } from "rest/requests";
import DetailsCategoryDialog from "./components/DetailsCategoryDialog";

function MarketAnalysis() {
  const [showChart, setShowChart] = useState(false);

  const catalogSector = getCatalogSectorsSync();
  const catalogSubSector = getCatalogSubSectorsSync();
  const catalogGroups = getCatalogGroupsSync();
  const catalogCategories = getCatalogCategoriesSync();

  const [selectedSectors, setSelectedSectors] = useState([]);
  const [selectedSubSectors, setSelectedSubSectors] = useState([]);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);

  const [selectedReportType, setSelectedReportType] = useState(reportType[0].id);
  const [selectedDetailLevel, setSelectedDetailLevel] = useState(detailLevel[0].id);
  const [selectedData, setSelectedData] = useState(data[0].id);
  const [selectedTerms, setSelectedTerms] = useState(terms[0].id);

  const [product, setProduct] = useState("");

  const [analisysResults, setAnalisysResults] = useState([]);

  // ------ Year select ----------
  const current_year = new Date().getFullYear();
  const [year, setYear] = useState(current_year);
  const handleYear = (event) => {
    const {
      target: { value },
    } = event;
    if (value <= current_year) {
      setYear(value);
    }
  };
  // ------ Year select END----------

  const getData = useCallback(async () => {
    if (String(year).length == 4) {
      const data = {
        tipoReporte: selectedReportType,
        nivelDetalle: selectedDetailLevel,
        tipoDatos: selectedData,
        periodo: selectedTerms,
        sectorsId: selectedSectors,
        subsectorsId: selectedSubSectors,
        groupsId: selectedGroups,
        categoriesId: selectedCategories,
        year: year,
      };

      if (String(product).length > 0) {
        data["productName"] = product;
      }

      console.log("Request Payload", data);
      const _analisysResults = await analysisVeterinaryMarket(data);
      setAnalisysResults(_analisysResults);
    }
  }, [
    year,
    selectedReportType,
    selectedDetailLevel,
    selectedData,
    selectedTerms,
    selectedSectors,
    selectedSubSectors,
    selectedGroups,
    selectedCategories,
    product,
  ]);

  const searchResults = () => {
    getData();
  };

  useEffect(() => {
    getData();
  }, [
    year,
    selectedReportType,
    selectedDetailLevel,
    selectedData,
    selectedTerms,
    selectedSectors,
    selectedSubSectors,
    selectedGroups,
    selectedCategories,
    product,
  ]);

  //Modal Detail Empresas states
  const [openCompanyDetailsModal, setOpenCompanyDetailsModal] = useState(false);
  const [selectedCompanyId, setSelectedCompanyId] = useState(null);
  const [selectedCompanyData, setSelectedCompanyData] = useState([]);

  const getCompanyDetailData = useCallback(async () => {
    // companyId,
    // year,
    // tipoReporte,
    // nivelDetalle,
    // tipoDatos,
    // periodo,
    // sectorsId,
    // subsectorsId,
    // groupsId,
    // categoriesId
    setSelectedCompanyData(
      await reportAnalysisVeterinaryMarketDetail(
        selectedCompanyId,
        year,
        selectedReportType,
        selectedDetailLevel,
        selectedData,
        selectedTerms,
        selectedSectors,
        selectedSubSectors,
        selectedGroups,
        selectedCategories
      )
    );
    setOpenCompanyDetailsModal(true);
  }, [selectedCompanyId]);

  useEffect(() => {
    if (selectedCompanyId) {
      getCompanyDetailData();
    }
  }, [selectedCompanyId]);

  //Modal Detail Category states
  const [openCategoryDetailsModal, setOpenCategoryDetailsModal] = useState(false);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [selectedCategoryData, setSelectedCategoryData] = useState([]);

  const getCategoryDetailData = useCallback(async () => {
    setSelectedCategoryData(
      await reportAnalysisVeterinaryMarketDetailCategory(
        selectedCategoryId,
        year,
        selectedReportType,
        selectedDetailLevel,
        selectedData,
        selectedTerms,
        selectedSectors,
        selectedSubSectors,
        selectedGroups,
        selectedCategories
      )
    );
    setOpenCategoryDetailsModal(true);
  }, [selectedCategoryId]);

  useEffect(() => {
    if (selectedCategoryId) {
      getCategoryDetailData();
    }
  }, [selectedCategoryId]);

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <TitleCustom
        title={"Analisis del Mercado "}
        excelData={getExcelData(analisysResults, selectedData, year, selectedDetailLevel)}
        excelName={"AnalisisDelMercado.xlsx"}
        showChart={showChart}
        setShowChart={setShowChart}
      ></TitleCustom>

      <MDBox bgColor="white" variant="contained" borderRadius="lg" shadow="lg" opacity={1} p={2}>
        <Grid container spacing={1} style={{ paddingBottom: "5px" }}>
          <Grid item>
            <CommonSelectWithoutNoneOption
              data={reportType}
              label={"Tipo Reporte"}
              onChange={(selectedValue) => setSelectedReportType(selectedValue)}
              defaultValue={selectedReportType}
            ></CommonSelectWithoutNoneOption>
          </Grid>
          <Grid item>
            <CommonSelectWithoutNoneOption
              data={detailLevel}
              label={"Nivel de detalles"}
              onChange={(selectedValue) => setSelectedDetailLevel(selectedValue)}
              defaultValue={selectedDetailLevel}
            ></CommonSelectWithoutNoneOption>
          </Grid>
          <Grid item>
            <CommonSelectWithoutNoneOption
              data={data}
              label={"Datos"}
              onChange={(selectedValue) => setSelectedData(selectedValue)}
              defaultValue={selectedData}
            ></CommonSelectWithoutNoneOption>
          </Grid>
          <Grid item>
            <CommonSelectWithoutNoneOption
              data={terms}
              label={"Periodo"}
              onChange={(selectedValue) => setSelectedTerms(selectedValue)}
              defaultValue={selectedTerms}
            ></CommonSelectWithoutNoneOption>
          </Grid>
        </Grid>

        <Grid container spacing={1} style={{ paddingBottom: "5px" }}>
          <Grid item>
            <MultipleSelectChip
              key="Sector"
              label="Sector"
              data={getSector(catalogSector)}
              onChange={(selectedValue) => setSelectedSectors(selectedValue)}
            />
          </Grid>
          <Grid item>
            <MultipleSelectChip
              key="SubSector"
              label="SubSector"
              data={getSubSector(selectedSectors, catalogSubSector)}
              onChange={(selectedValue) => setSelectedSubSectors(selectedValue)}
            />
          </Grid>
          <Grid item>
            <MultipleSelectChip
              key="Grupo"
              label="Grupo"
              data={getGrupos(selectedSubSectors, catalogGroups)}
              onChange={(selectedValue) => setSelectedGroups(selectedValue)}
            />
          </Grid>
          <Grid item>
            <MultipleSelectChip
              key="Categoria"
              label="Categoria"
              data={getCategories(selectedGroups, catalogCategories)}
              onChange={(selectedValue) => setSelectedCategories(selectedValue)}
            />
          </Grid>
        </Grid>

        <Grid container spacing={1} style={{ paddingBottom: "5px" }}>
          <Grid item>
            <MDInput
              style={{ minWidth: "310px" }}
              type="number"
              label="Year"
              value={year}
              onChange={handleYear}
            />
          </Grid>
          <Grid item>
            <MDInput
              style={{ minWidth: "308px", marginLeft: "7px" }}
              label="Nombre de Producto ..."
              onChange={(event) => setProduct(event.target.value)}
            />
          </Grid>
          <Grid item>
            <MDButton variant="gradient" color="success" onClick={() => searchResults()}>
              <Icon>search</Icon>
              &nbsp;Buscar
            </MDButton>
          </Grid>
        </Grid>
      </MDBox>
      <br></br>
      {showChart ? (
        <MarketAnalysisCharts
          data={analisysResults}
          params={{
            year,
            selectedReportType,
            selectedDetailLevel,
            selectedData,
            selectedTerms,
            selectedSectors,
            selectedSubSectors,
            selectedGroups,
            selectedCategories,
            product,
          }}
        ></MarketAnalysisCharts>
      ) : (
        <MarketAnalysisTable
          data={analisysResults}
          setSelectedCompanyId={setSelectedCompanyId}
          setSelectedCategoryId={setSelectedCategoryId}
          params={{
            year,
            selectedReportType,
            selectedDetailLevel,
            selectedData,
            selectedTerms,
            selectedSectors,
            selectedSubSectors,
            selectedGroups,
            selectedCategories,
            product,
          }}
        />
      )}
      {openCompanyDetailsModal ? (
        <DetailsDialog
          open={openCompanyDetailsModal}
          setOpen={setOpenCompanyDetailsModal}
          modalData={selectedCompanyData}
          dataType={selectedData}
        ></DetailsDialog>
      ) : (
        <></>
      )}

      {openCategoryDetailsModal ? (
        <DetailsCategoryDialog
          open={openCategoryDetailsModal}
          setOpen={setOpenCategoryDetailsModal}
          modalData={selectedCategoryData}
          dataType={selectedData}
        ></DetailsCategoryDialog>
      ) : (
        <></>
      )}

      <Footer />
    </DashboardLayout>
  );
}

export default MarketAnalysis;
